import React, { createContext, useContext, useEffect, useState } from "react";
import { auth as authApi } from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cv_token");
    if (!token) {
      setLoading(false);
      return;
    }
    authApi
      .me()
      .then(setUser)
      .catch(() => localStorage.removeItem("cv_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { token } = await authApi.login({ email, password });
    localStorage.setItem("cv_token", token);
    // Fetch the full user doc (including is_admin, is_demo) via /auth/me so admin
    // gating in the router has the right context immediately after login.
    const fullUser = await authApi.me();
    setUser(fullUser);
    return fullUser;
  };

  const register = async (data) => {
    const { token } = await authApi.register(data);
    localStorage.setItem("cv_token", token);
    const fullUser = await authApi.me();
    setUser(fullUser);
    return fullUser;
  };

  const logout = () => {
    localStorage.removeItem("cv_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, register, logout }}>{children}</AuthCtx.Provider>;
};

export const useAuth = () => useContext(AuthCtx);
